import theme from "styles/theme"
import { Color, Uuid } from "./global"


/**
 * Livello di severity dell'allarme
 * https://airilabs.myjetbrains.com/youtrack/articles/ZOS-A-259/ALARMS#severity
 */
export enum ALARM_SEVERITY {
	CRITICAL = 5,
	HIGH = 4,
	MODERATE = 3,
	LOW = 2,
	INFORMATION = 1,
}
/**
 * Il tipo della struttura che definisce la severity di un allarme
 * i valori sono settati in ALARM_SEVERITY
 */
export interface AlarmSeverity {
	id: ALARM_SEVERITY,
	label: string
	color: Color
	colorFg: Color
}
/**
 * Dati riguardo le singole SEVERITY
 */
export const AlarmSeverityData: AlarmSeverity[] = [
	{ id: ALARM_SEVERITY.CRITICAL, label: "critical", color: "#ed3833", colorFg: theme.palette.common.white },
	{ id: ALARM_SEVERITY.HIGH, label: "high", color: "#f28b43", colorFg: theme.palette.text.negative },
	{ id: ALARM_SEVERITY.MODERATE, label: "moderate", color: "#f3c846", colorFg: theme.palette.text.negative },
	{ id: ALARM_SEVERITY.LOW, label: "low", color: "#71cf36", colorFg: theme.palette.text.negative },
	{ id: ALARM_SEVERITY.INFORMATION, label: "information", color: "#3a8222", colorFg: theme.palette.text.negative },
]
export function getSeverityData(severity:ALARM_SEVERITY) {
	return AlarmSeverityData.find(as => as.id == severity)
}


/**
 * I team di competenze per la gestione degli allarmi
 * https://airilabs.myjetbrains.com/youtrack/articles/ZOS-A-259/ALARMS#team
 */
export enum ALARM_TEAM {
	TECHNICAL_MANAGER = "technical_manager",
	ENGINEERS = "engineers",
	AGRO_GUYS = "agro_guys",
	ICT_GUYS = "ict_guys",
}


export interface AlarmDefault {
	description?: string
	wikiUrl?: string
	severity?: ALARM_SEVERITY
	teams?: ALARM_TEAM[]
	taskTemplateGroupUuid?: Uuid,
}

/**
 * Tipologia di GROW-UNIT su cui e' possibile fare un override
 * caricata da `GET alarms/typologies`
 */
export interface AlarmTypology {
	/** il codice che viaggia in `typologiesOverrided` */
	code: string
	/** label leggibile, fornita dal BE */
	label: string
}

export interface AlarmOverride extends AlarmDefault {
	typologiesOverrided?: string[]
}

/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-27835
 */
export interface Alarm {
	alarmCode?: string
	newAlarmCode?: string
	management?: {
		default?: AlarmDefault
		typologyOverrides?: AlarmOverride[]
	}
}
